module.exports = __webpack_public_path__ + "static/web-app-element-1-3c7c0d644fe58cf2a2e4bab7a062a047.png";